import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { KeyDatesModalComponent } from 'src/app/private/sale/home/key-dates-modal/key-dates-modal.component';
import { ICON } from '@core/util/icon';
import {
	MissingFieldSection,
	PROFILE_ID_QUERY_PARAM_VALUE,
} from '../../services/validate-stewart-data.service';
import { take } from 'rxjs/operators';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { ActivatedRoute } from '@angular/router';
import { AddTitleInsuranceComponent } from '../../../components/add-title-insurance/add-title-insurance.component';
import { StewartModalComponent } from '../../stewart-modal/stewart-modal.component';
import { StewartStatus } from '@models/title-insurance/stewart';
import { BlankTitleInsurance } from '../../../chicago/chicago.component';
import {
	StewartCancelModalData,
	StewartCancelModalComponent,
} from '../cancel-modal/cancel-modal.component';
import { StewartProfileIdsComponent } from '@components/stewart-profile-ids/stewart-profile-ids.component';
import { UrlService } from 'src/app/shared/services/url/url.service';
import { ChangePriorityComponent } from 'src/app/private/sale/mortgages/manual/components/change-priority/change-priority.component';
import { TestHooks } from './not-submitted.hooks';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';

@UntilDestroy()
@Component({
	selector: 'app-stewart-not-submitted',
	templateUrl: './not-submitted.component.html',
	styleUrls: ['./not-submitted.component.scss'],
	standalone: false,
})
export class StewartNotSubmittedComponent implements OnInit, AfterViewInit {
	testHooks = TestHooks;
	public blankTitleInsurance = BlankTitleInsurance;
	public ICON = ICON;
	backUrlParams = { 'back-string': 'Title insurance' };
	keyDatesModalParams = { modal: 'keyDates' };
	public StewartStatus = StewartStatus;
	public propertyUrl: string;
	@Input() changePropertyButtonText: string;
	@Input() canSubmit = false;
	@Input() missing: MissingFieldSection[] = [];
	@Input() orderValid = false;
	@Input() status;
	@Input() statusText: string;
	@Input() isOther = false;
	@Input() isMobileHome = false;
	@Input() outOfOntario = false;
	@Input() isCommercial = false;
	@Input() showPriorityWarning = false;

	@SelectSnapshot(SelectedMatter.titleInsuranceThirdPartyId)
	thirdPartyId: number;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(
		private dialog: MatDialog,
		private route: ActivatedRoute,
		private navService: NavigationService,
		private matterDispatch: MatterDispatch,
		private matDialog: MatDialog,
		private drawerService: DrawerService,
	) {}

	ngOnInit(): void {
		this.propertyUrl = UrlService.Matter_Property_Details(this.matterId);
	}

	selectInsuranceProvider() {
		this.dialog.open(AddTitleInsuranceComponent);
	}

	openPortal() {
		if (!this.orderValid) {
			return;
		}
		this.dialog.open(StewartModalComponent);
	}

	openProfileIdModal() {
		const modalRef = this.dialog.open(StewartProfileIdsComponent);

		modalRef
			.afterClosed()
			.pipe(take(1))
			.subscribe(() => {
				this.navService.goToMatter_TitleInsurance(this.matterId);
			});
	}

	openKeyDatesDrawer(event: Event) {
		event.preventDefault();

		this.drawerService.openDrawer(KeyDatesModalComponent, {
			size: 'md',
			title: 'Key Dates',
			noStyle: true,
		});
	}

	ngAfterViewInit(): void {
		this.route.queryParams
			.pipe(untilDestroyed(this))
			.subscribe((queryparams) => {
				const { modal } = queryparams;

				if (modal === PROFILE_ID_QUERY_PARAM_VALUE) {
					this.openProfileIdModal();
				}
			});
	}

	cancel(): void {
		const data: StewartCancelModalData = {
			status: this.status,
		};

		const modalRef = this.matDialog.open(StewartCancelModalComponent, {
			data,
			maxWidth: '450px',
			width: '90%',
		});

		modalRef
			.afterClosed()
			.pipe(take(1))
			.subscribe((value) => {
				if (value) {
					this.matterDispatch.SetTitleInsurance(
						this.matterId,
						this.blankTitleInsurance,
					);
				}
			});
	}

	editPriority(): void {
		this.matDialog.open(ChangePriorityComponent, { panelClass: 'gradient' });
	}
}
